// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3Z2il","legacyBtn":"MutateMid_legacyBtn__3Pj3V"};